<template>
  <b-modal
    id="modal-multi-property"
    size="lg"
    title="Gebäude erfassen"
    v-model="isPropertyModalVisible"
  >
    <b-alert v-model="hasError" variant="warning">
      {{ errorMessage }}
    </b-alert>

    <b-alert v-model="hasUnknownError" variant="danger">
      {{ unknownErrorMessage }}
    </b-alert>

    <type-ahead :form="form" />

    <validation-observer ref="observer" v-slot="{ passes }"  v-if="isFormVisible">
      <b-form @submit.prevent="passes(onSubmit)">
        <property-add :form="form" />
      </b-form>
    </validation-observer>

    <template v-slot:modal-footer="{ hide }">
      <div class="w-100 button-wrapper">
        <div v-if="isFormVisible">
          <b-button type="submit" variant="primary" disabled v-if="isSubmitting" class="float-right">
            <b-spinner small></b-spinner>
            Speichern & übernehmen
          </b-button>
          <b-button @click="onSubmit" variant="primary" v-else class="float-right">Speichern & übernehmen</b-button>
        </div>

        <b-button class="float-right" @click="hide(reset())">
          Schliessen
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import { mapState } from 'vuex'
  import { ValidationObserver } from 'vee-validate'
  import { errorHandler } from '@/helpers/formHelper.js'
  import PropertyAdd from '@/components/property/PropertyAdd.vue'
  import TypeAhead from '@/components/property/TypeAhead.vue'

  const getInitialData = () => ({
    form: {
      strasse: '',
      hausNr: '',
      plz: '',
      ort: '',
      egid: '',
      versicherungsNr: '',
      parzellenNr: '',
      gebaeudeart: 80,
      nutzung: 28,
      baujahr: null,
      anzahlWohnungen: null,
      energiebezugsflaeche: null,
      hauptwaermeerzeugungBestehend: 173,
      hauptwaermeerzeugungBestehendAndere: '',
      hauptwaermeerzeugungNeu: 173,
      denkmalgeschuetzt: false,
      gemeindeId: null
    }
  })

  export default {
    components: {
      ValidationObserver,
      PropertyAdd,
      TypeAhead
    },
    data: () => ({
      isSubmitting: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      hasError: false,
      errorMessage: '',
      ...getInitialData()
    }),
    methods: {
      onSubmit () {
        this.$refs.observer.validate().then(success => {
          if (!success) {
            return
          }

          this.isSubmitting = true
          this.hasUnknownError = false
          this.hasError = false

          this.$store.dispatch('property/SAVE_PROPERTY', this.form).then(res => {
            const { errors } = res

            if (errors) {
              this.isSubmitting = false
              return errorHandler(this, errors)
            }

            this.$store.commit('application/SET_PROPERTY_MODAL_VISIBLE', {
              boolShow: false
            })
            this.isSubmitting = false
            this.reset()
          }).catch(err => {
            this.hasUnknownError = true
            this.unknownErrorMessage = this.$t('formError.unknownwError')
            this.isSubmitting = false
            console.error(err)
          })
        })
      },
      reset () {
        Object.assign(this.$data, getInitialData())
        requestAnimationFrame(() => {
          this.$refs.observer.reset()
        })
      }
    },
    computed: {
      ...mapState({
        isFormVisible: state => state.property.propertyAdd.isFormVisible
      }),
      isPropertyModalVisible: {
        set (value) {
          this.$store.commit('application/SET_PROPERTY_MODAL_VISIBLE', {
            boolShow: value
          })
        },
        get () {
          return this.$store.state.application.isPropertyModalVisible
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .button-wrapper{
    .btn{
      margin-left: 1rem;
    }
  }
  .optional{
    text-decoration: underline;
  }
</style>
